"use client";
import { LinkProvider, type LinkRenderer } from "@softmax/design-system";
import type { ReactNode } from "react";
import {
  NavigationContext,
  type FeatureNavigation,
} from "./navigation-context";

export function FeatureNavigationProvider({
  value,
  renderLink,
  children,
}: {
  readonly value: FeatureNavigation;
  readonly renderLink: LinkRenderer;
  readonly children: ReactNode;
}) {
  return (
    <NavigationContext value={{ navigation: value, renderLink }}>
      <LinkProvider renderLink={renderLink}>{children}</LinkProvider>
    </NavigationContext>
  );
}
